import Typography from '@mui/material/Typography'
import React, { useEffect, useState } from 'react'

const RecipientPaymentsActions = (props) => {
  const [text, setText] = useState('')

  useEffect(() => {
    if (!props.dwollaFundingSourceId) {
      setText('No')
      return
    }
    setText('Yes')
  }, [props])
  return <Typography variant='primary'>{text}</Typography>
}

export default RecipientPaymentsActions
